'use client';

import React from 'react';

export default function FinalCTASection() {
  return (
    <section
      id="cta"
      className="relative py-20 overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #FBFAF6 0%, #EEF4F8 50%, #FBFAF6 100%)' }}
      aria-label="Final call to action"
    >
      {/* Ambient */}
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
        <div
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[500px] opacity-20"
          style={{ background: 'radial-gradient(ellipse, rgba(31,77,63,0.1) 0%, transparent 65%)', filter: 'blur(70px)' }}
        />
        <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'rgba(211,223,219,0.8)' }} />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Eyebrow */}
        <div className="flex justify-center mb-8">
          <div
            className="flex items-center gap-2 px-4 py-2 rounded-full"
            style={{ background: 'rgba(31,77,63,0.07)', border: '1px solid rgba(31,77,63,0.12)' }}
          >
            <span className="w-1.5 h-1.5 rounded-full animate-pulse" style={{ background: '#1F4D3F' }} />
            <span
              style={{
                fontFamily: 'var(--font-mono)',
                fontSize: '11px',
                letterSpacing: '0.06em',
                color: '#1F4D3F',
                textTransform: 'uppercase',
              }}
            >
              Ready when you are
            </span>
          </div>
        </div>

        {/* Headline */}
        <h2
          style={{
            fontFamily: 'var(--font-sans)',
            fontWeight: 600,
            fontSize: 'clamp(2.2rem, 5vw, 3.6rem)',
            letterSpacing: '-0.035em',
            color: '#0D2620',
            lineHeight: 1.1,
            marginBottom: '24px',
          }}
        >
          Stop running your business
          <br />
          <span style={{ color: '#1F4D3F' }}>from memory.</span>
        </h2>

        {/* Subheadline */}
        <p
          style={{
            fontFamily: 'var(--font-sans)',
            fontSize: 'clamp(1rem, 1.8vw, 1.15rem)',
            color: '#3D5550',
            lineHeight: 1.75,
            maxWidth: '520px',
            margin: '0 auto 40px',
          }}
        >
          Let vina remember the numbers,
          <br />
          find the patterns,
          <br />
          and surface what matters.
        </p>

        {/* CTAs */}
        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="https://vasy.ai/india-avail-free-demo?utm_source=lp&utm_medium=web&utm_campaign=teamvina"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full font-medium text-base transition-all"
            style={{
              background: '#1F4D3F',
              color: '#FFFFFF',
              letterSpacing: '-0.01em',
              boxShadow: '0 8px 32px rgba(31,77,63,0.3)',
            }}
            onMouseEnter={e => {
              (e.currentTarget as HTMLElement).style.background = '#29584B';
              (e.currentTarget as HTMLElement).style.boxShadow = '0 12px 40px rgba(31,77,63,0.4)';
            }}
            onMouseLeave={e => {
              (e.currentTarget as HTMLElement).style.background = '#1F4D3F';
              (e.currentTarget as HTMLElement).style.boxShadow = '0 8px 32px rgba(31,77,63,0.3)';
            }}
          >
            Schedule a Free Demo Now
          </a>
          <a
            href="#live-product"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full font-medium text-base transition-all"
            style={{
              color: '#1F4D3F',
              border: '1px solid rgba(31,77,63,0.25)',
              background: 'rgba(31,77,63,0.04)',
              letterSpacing: '-0.01em',
            }}
            onMouseEnter={e => { (e.currentTarget as HTMLElement).style.background = 'rgba(31,77,63,0.08)'; }}
            onMouseLeave={e => { (e.currentTarget as HTMLElement).style.background = 'rgba(31,77,63,0.04)'; }}
          >
            See vina in action
          </a>
        </div>

        {/* Trust micro-copy */}
        <p className="mt-8" style={{ fontFamily: 'var(--font-mono)', fontSize: '11px', color: '#9AADA7', letterSpacing: '0.03em' }}>
          Powered by Vasy · Works with your existing business data · Live in minutes
        </p>
      </div>
    </section>
  );
}
